import React from "react";
import styled from "styled-components";
import { useTranslation } from "react-i18next";

const Container = styled.div`
  border: 3px solid #ff8f4e;
  border-radius: 10px;
  padding: 1.5rem;
  width: 100%;
  display: flex;
  flex-direction: column;
  height: 100%;
`;

const StyledList = styled.ul`
  list-style-type: disc;
  padding-left: 1.5rem;
`;

const IndiaAIFestivalSpecialAwards = ({ data }) => {
  const { t } = useTranslation();

  return (
    <div className="w-100">
      <Container>
        {data.groups.map((group, index) => (
          <div key={index} className="mb-4">
            <h2 className="text-center mb-3">{group.title}</h2>
            <StyledList>
              {group.categories.map((category, idx) => (
                <li key={idx}>
                  <strong>{category.title}</strong>{" "}
                  {category.items.map((item, itemIndex) => (
                    <span key={itemIndex}>
                      {item.description}{" "}
                      {category.note && (
                        <>
                          {category.note.text}{" "}
                          <a
                            href={category.note.url}
                            className="text-primary font-weight-bold"
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            {category.note.linkText}
                          </a>
                        </>
                      )}
                    </span>
                  ))}
                </li>
              ))}
            </StyledList>
          </div>
        ))}
      </Container>
    </div>
  );
};

export default IndiaAIFestivalSpecialAwards;
